export default {
  title: 'Contribuição ao KPI de Marketing por Microaudiência (USD)',
  infoDialog: 'Contribuição projetada ao KPI por microaudiências demográficas',
  kpi: 'KPI'
}
